/**
 * Replace character(s) on a string with a given 'replacer' string.
 * Accepts regex for better matching.
 */

export default (Vue) => {
	Vue.filter('inv-replace', (value, replacee, replacer) => {
		return replace(value, replacee, replacer);
	});

	Vue.prototype.$invReplace = (value, replacee, replacer) => {
		return replace(value, replacee, replacer);
	};

	/**
	 * Replace character(s) on a string with a given 'replacer' string.
	 * Accepts regex for better matching.
	 *
	 * @param {string} value
	 * @param {string} replacee
	 * @param {string} replacer
	 */
	function replace(value, replacee, replacer) {
		if (! value) {
			return '';
		}

		return value.replace(replacee, replacer);
	}
};